angular.module('tasks')
    .controller('TaskPeriodChangeDialogController', function ($uibModalInstance, data, Task, TaskService) {
        this.$onInit = () => {
            Task.get({id: data.id}).$promise
                .then(entity => {
                    this.task = entity;
                    this.item = angular.copy(entity);

                    if (data.period) {
                        angular.extend(this.item, data.period);
                    }
                    this.collisionCheck()
                })
                .catch(() => $uibModalInstance.dismiss('Failed'));
        }

        this.setEndTime = hours => {
            this.item.endTime = moment(this.item.startTime).add(hours, 'h');
            this.collisionCheck();
        };

        this.collisionCheck = () => {
            let task = this.item
            let taskSlotCheckForm = {
                id: task.id,
                workers: task.workers,
                startTime: task.startTime ? moment(task.startTime) : null,
                endTime: task.endTime ? moment(task.endTime) : null
            }
            Task.taskSlotCheck(taskSlotCheckForm).$promise.then(taskCollisions => this.taskCollisions = taskCollisions);
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            let periodData = {
                startTime: this.item.startTime,
                endTime: this.item.endTime
            };
            return TaskService.updateTimeWithTimeSlotCheck(this.item, periodData).then(() => $uibModalInstance.close('saved'))
        };
    })
